import { KpiIds, KpiModel, kpiDirectionOf } from '@core/models/kpi.model';

import {
  KpiTone,
  displayResolution,
  formatKpiDelta,
  kpiTone
} from '@shared/components/kpi-comparison/kpi-comparison.model';

export type ImpactReference = 'saved' | 'before';

export interface ImpactKpiTile {
  id: KpiIds;
  i18nKey: string;
  value: string;
  saved: string | null;
  before: string | null;
  /** Null when the KPI has no number, the reference lacks it, or the values are provisional. */
  delta: string | null;
  tone: KpiTone | null;
}

export function impactKpiTiles(args: {
  current: KpiModel[];
  saved: KpiModel[];
  before: KpiModel[] | null;
  reference: ImpactReference;
  showDeltas: boolean;
  decimals: number;
}): ImpactKpiTile[] {
  const { current, reference, showDeltas, decimals } = args;
  const savedById = new Map(args.saved.map((kpi) => [kpi.id, kpi]));
  // A round measured before the watch carried KPIs has none, and the plan then stood as saved.
  const beforeById = args.before
    ? new Map(args.before.map((kpi) => [kpi.id, kpi]))
    : savedById;
  const referenceById = reference === 'saved' ? savedById : beforeById;

  return current.map((kpi) => {
    const referenceValue = referenceById.get(kpi.id)?.numericValue ?? null;
    const currentValue = kpi.numericValue;
    const comparable = showDeltas && currentValue !== null && referenceValue !== null;
    const diff = comparable ? currentValue - referenceValue : null;

    return {
      id: kpi.id,
      i18nKey: kpi.i18nKey,
      value: kpi.value,
      saved: savedById.get(kpi.id)?.value ?? null,
      before: beforeById.get(kpi.id)?.value ?? null,
      delta: diff === null ? null : formatKpiDelta(kpi.id, diff, kpi.metadata, decimals),
      tone:
        diff === null
          ? null
          : kpiTone(kpiDirectionOf(kpi.id), diff, displayResolution(kpi.id, decimals))
    };
  });
}
